/*
 * Public API Surface of Modal Component
 */

export * from './modal.module';

export * from './interfaces/modal-component';

export * from './models/modal-buttons.model';
export * from './models/modal.model';
export * from './models/modal-button-type.enum';
export * from './models/modal-content-type.enum';

export * from './components/base-modal/base-modal.component';
export * from './components/modal/modal.component';
export * from './components/confirm-delete-modal/confirm-delete-modal.component';

export * from './directives/modal-confirm.directive';
